import { render, staticRenderFns } from "./LinksEditor.vue?vue&type=template&id=db0d76ba"
import script from "./LinksEditor.vue?vue&type=script&lang=js"
export * from "./LinksEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports